/* import __COLOCATED_TEMPLATE__ from './video.hbs'; */
import Component from '@glimmer/component';
import { assert } from '@ember/debug';
import { isNone } from '@ember/utils';
import type Owner from '@ember/owner';

///////////////////////////////////////////////////////////////////////////////
// aditools-video-dialog - display available videos in two columns           //
///////////////////////////////////////////////////////////////////////////////

interface VideoDialogArgs {
  videoIds: string[]; // The relative translation IDs of each video
  translationRoot: string; // The root translation string for all videos
  translationParms: { [parmName: string]: string }; // Hash of parms
  close: () => void; // Action to perform when closing the dialog
}
export default class DialogVideo extends Component<VideoDialogArgs> {
  ///////////////////////////////////////////////////////////////////////////
  // Instance properties                                                   //
  ///////////////////////////////////////////////////////////////////////////
  title!: string; // The translation ID of the dialog title
  heading!: string; // The translation ID of the dialog heading

  ///////////////////////////////////////////////////////////////////////////
  // Initialization                                                        //
  ///////////////////////////////////////////////////////////////////////////
  constructor(owner: Owner, args: VideoDialogArgs) {
    super(owner, args);
    // Template parameter validation
    assert('`videoIds` is required', !isNone(this.args.videoIds));
    assert('`translationRoot` is required', !isNone(this.args.translationRoot));
    assert('`translationParms is required', !isNone(this.args.translationParms));
    assert('`close` is required', !isNone(this.args.close));

    //Instance property initialization
    this.title = `${this.args.translationRoot}.title`;
    this.heading = `${this.args.translationRoot}.heading`;
  }
  ////////////////////////////////////////////////////////////////////////////////
  // Computed Properties                                                        //
  ////////////////////////////////////////////////////////////////////////////////
  get leftVideos(): { title: string; url: string }[] {
    const halfmark = Math.round(this.args.videoIds.length / 2);
    const result = [];
    for (let i = 0; i < halfmark; i++) {
      result.push({
        title: `${this.args.translationRoot}.${this.args.videoIds[i]}.title`,
        url: `${this.args.translationRoot}.${this.args.videoIds[i]}.url`,
      });
    }
    return result;
  }

  get rightVideos(): { title: string; url: string }[] {
    const halfmark = Math.round(this.args.videoIds.length / 2);
    const result = [];
    for (let i = halfmark; i < this.args.videoIds.length; i++) {
      result.push({
        title: `${this.args.translationRoot}.${this.args.videoIds[i]}.title`,
        url: `${this.args.translationRoot}.${this.args.videoIds[i]}.url`,
      });
    }
    return result;
  }
}
